import { BASE_URL } from "../constants";
import { UserEntity } from "../entities/UserEntity";
import FetchUtils from "../utils/fetch";

class UserService {
    static async GetAllUser(): Promise<UserEntity[]> {
        let resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/users`);
        if (resp.status != 200) { throw resp.message }

        const data: UserEntity[] = [];
        for (let i = 0; i < resp.data.length; i++) {
            data.push(new UserEntity({
                id: resp.data[i].ID,
                id_grup: resp.data[i].IDGrup,
                id_vendor: resp.data[i].IDVendor,
                vendor: resp.data[i].Vendor,
                username: resp.data[i].Username,
                rolename: resp.data[i].Grup,
            }))
        }

        return data;
    }

    static async GetAllGrup(): Promise<{ id: number, grup: string }[]> {
        let resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/users/grup`);
        if (resp.status != 200) { throw resp.message }
        const data: { id: number, grup: string }[] = [];
        for (let i = 0; i < resp.data.length; i++) {
            data.push({ id: resp.data[i].ID, grup: resp.data[i].Grup })
        }

        return data;
    }

    static async AddUser(data: { id_grup: number, id_vendor?: number, username: string }): Promise<{ message: string }> {
        let resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/users/add`,
            {
                method: 'POST',
                body: JSON.stringify({ ...data })
            }
        );
        if (resp.status != 200) { throw resp.message }
        return resp;
    }

    static async ChangePassword(user: UserEntity, newpassword: string): Promise<{ message: string }> {
        let resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/users/change_pass`,
            {
                method: 'POST',
                body: JSON.stringify({ id: user.id, newpassword })
            }
        );
        if (resp.status != 200) { throw resp.message }

        return resp;
    }

    static async UpdateUser(user: UserEntity, fields: { id_grup?: number, id_vendor?: number, username?: string }): Promise<{ message: string }> {
        if (fields.id_grup == 1) {
            fields = {
                username: fields.username,
                id_grup: fields.id_grup
            }
        }
        let resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/users/update`,
            {
                method: 'PUT',
                body: JSON.stringify({ id: user.id, fields })
            }
        );
        if (resp.status != 200) { throw resp.message }

        return resp;
    }

    static async DeleteUser(data: UserEntity): Promise<{ message: string }> {
        let resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/users/delete`,
            {
                method: 'DELETE',
                body: JSON.stringify({ id: data.id })
            }
        );
        if (resp.status != 200) { throw resp.message }

        return resp;
    }
}

export { UserService };